package com.gsb.vyapar.bhagya.theme

import androidx.compose.ui.graphics.Color

val background = Color(0xFFFFFFFF)
val primary = Color(0xFFFF9933)
val white = Color(0xFFFFFFFF)
val black = Color(0xFF000000)
val hintColor = Color(0x80000000)
val message = Color(0xFF676767)
val focussed = Color(0xFF484848)
val unfocussed = Color(0xFFDDDDE0)
val unselected = Color(0xFF6A6A73)
val navbackground = Color(0xFFF2F4F5)
val offwhite = Color(0xFFFAF9F6)
val green = Color(0xFF47BA7C)
val splashBack = Color(0xFFFF9933)
val tabUnselect = Color(0xFF999999)